<template>
  <div class="dashbord_area">
    <HeaderDashbord></HeaderDashbord>
    <div class="dashbord_area_inner">

      <aside>
        <ul>
          <li v-bind:class="{ active: isintro }"><a @click="getPage('Intro')" href="#"><i class="fas fa-chart-bar"></i> لوحة التحكم</a></li>
          <li v-bind:class="{ active: isgames }"><a @click="getPage('Games')" href="#"><i class="fas fa-gamepad"></i> الألعاب</a></li>
          <li v-bind:class="{ active: issettings }"><a @click="getPage('Settings')" href="#"><i class="fas fa-cog"></i> الإعدادات</a></li>
        </ul>
      </aside>

      <section class="pages_area">
        <intro v-if="isintro"></intro>
        <games v-if="isgames"></games>
        <settings v-if="issettings"></settings>
      </section>

    </div>
  </div>
</template>

<script>

  import HeaderDashbord from '@/components/HeaderDashbord.vue'

  import intro from '@/views/dashboard/pages/Intro.vue'
  import games from '@/views/dashboard/pages/Games.vue'
  import settings from '@/views/dashboard/pages/Settings.vue'

  export default {
    name: 'Dashboard',
    components: {HeaderDashbord, intro, games, settings},
    data() {
      return {
        isintro: false,
        isgames: false,
        issettings: false,
      }
    },

    created() {
      this.getPage("Intro");
    },

    methods: {
      getPage: function (name) {

        this.isintro = false;
        this.isgames = false;
        this.issettings = false;

        switch (name) {
          case 'Intro':
            this.isintro = true;
            break;
          case 'Games':
            this.isgames = true;
            break;
          case 'Settings':
            this.issettings = true;
            break;
          default:
            break;
        }
      },
    },

  }
</script>

<style lang="scss" scoped>

</style>
